import { apiAddress } from "../../config/server";
import { IComment } from "../../types/comments/Comment";
import { ICompetition } from "../../types/competition/Competition";
import { ITeam } from "../../types/team/Team";
import { ApiBase } from "./baseApi";

export interface ITeamSearchOptions {
  name?: string;
  associationId?: string;
  seasonId?: string;
  competitionId?: string;
  dayOfWeek?: number; // 0-6, Sunday = 0
  dateFrom?: Date | string;
  dateTo?: Date | string;
  limit?: number;
  offset?: number;
}

export interface ITeamSearchResult extends ITeam {
  recentGames?: Array<{
    _id: string;
    date: Date | string;
    team1: string;
    team2: string;
    team1Name?: string;
    team2Name?: string;
    venue: string;
    court: string;
    competition: string;
    competitionName?: string;
  }>;
  upcomingGames?: Array<{
    _id: string;
    date: Date | string;
    team1: string;
    team2: string;
    team1Name?: string;
    team2Name?: string;
    venue: string;
    court: string;
    competition: string;
    competitionName?: string;
  }>;
  lastGameDate?: Date | string;
  nextGameDate?: Date | string;
  totalGames?: number;
}

export interface ITeamSearchResponse {
  teams: ITeamSearchResult[];
  competitions: ICompetition[];
  total: number;
}

export default class TeamApi extends ApiBase {
  static TeamApiAddress = `${apiAddress}/api/team/`;

  static GetAllTeams = TeamApi.TeamApiAddress;

  static GetById = TeamApi.TeamApiAddress;

  static getAllTeams(): Promise<ITeam[]> {
    return this.get(this.GetAllTeams).then((resp) => resp.data.teams || []);
  }

  static searchTeams(options: ITeamSearchOptions): Promise<ITeamSearchResponse> {
    return this.post(`${this.TeamApiAddress}search`, options).then(
      (resp) => ({
        teams: resp.data.teams || [],
        competitions: resp.data.competitions || [],
        total: resp.data.total || 0,
      }),
    );
  }

  static getTeamById(teamId: string): Promise<ITeam> {
    return this.get(this.TeamApiAddress + teamId).then(
      (resp) => resp.data.teams?.[0] as ITeam,
    );
  }

  static updateTeam(team: Partial<ITeam>) {
    if (!team._id) throw new Error("Need team._id to update team");

    return this.post(this.TeamApiAddress + team._id, team).then(
      (resp) => resp.data.teams?.[0] as ITeam,
    );
  }

  static getCommentsByTeamId(teamId: string): Promise<IComment[]> {
    return this.get<IComment[]>(`${this.TeamApiAddress + teamId}/comment`).then(
      (resp) => resp.data.data,
    );
  }

  static postCommentToTeam(
    teamId: string,
    content: string,
  ): Promise<IComment[]> {
    return this.post<IComment[]>(`${this.TeamApiAddress + teamId}/comment`, {
      content,
    } as IComment).then((resp) => resp.data.data);
  }
}
